import { string as yupString } from 'yup';

import { required } from '../../shared/forms/validators';
import InputFormik from '../../shared/forms/input/inputFormik.component';

const schema = [
  {
    name: 'functionalCurrency',
    component: InputFormik,
    meta: { label: 'Functional Currency' },
    additionalProps: { disabled: true },
  },
  {
    name: 'trialBalanceThreshold',
    component: InputFormik,
    meta: { label: 'Trial Balance Out Of Balance Threshold' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
];

export default schema;
